// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'arrow-right';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M2 9h13M8.933 3 15 9l-6.067 6'
  />
);

export const viewBox = '0 0 18 18';
